import { ApplicationClientCommonModule } from '@sdbn/appclient';
import { TransportPrognosisComponent } from './transport-prognosis.component';
import { MaterialModule } from '@sdbn/appclient';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CommonTranslationModule } from '@sdbn/common';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MaterialModule,
    CommonTranslationModule,
    ApplicationClientCommonModule
  ],
  declarations: [
    TransportPrognosisComponent]
})
export class TransportPrognosisModule { }
